// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-e9e5ab90]{min-height:100vh;display:flex;flex-direction:column;--padding-top:56px}@media(max-width:1050px){.content[data-v-e9e5ab90]{--padding-top:105px}}.ionic-base[data-v-e9e5ab90]{width:100%;height:100%;position:absolute}", ""]);
// Exports
module.exports = exports;
